<template>
  <v-text-field
    v-model="text"
    ref="input"
    id="search-input"
    type="text"
    tabindex="0"
    class="ma-0 pt-0 search-input"
    outlined
    maxlength="40"
    autocomplete="off"
    placeholder="חפש חברה..."
    background-color="#fff"
    color="primary"
    hide-details
  >
    <template v-slot:append>
      <v-icon class="icon-forma-1-copy-4" @click="searchCompany(text)" />
    </template>
    <template v-slot:prepend-inner>
      <v-icon @click="speechToText" v-if="showMic" >mdi-microphone</v-icon>
      <v-icon @click="stop" v-if="!showMic">mdi-microphone-off</v-icon>
    </template>
  </v-text-field>
</template>



<script>
export default {
  layout: 'innerPage',
  data() {
    return {
      showMic: true,
      rec: {},
      text: '',
    };
  },
  methods: {
    speechToText() {
      const speechRecognition =
        window.speechRecognition || window.webkitSpeechRecognition;
      if (speechRecognition) {
        const recognition = new speechRecognition();
        recognition.lang = 'he';
        this.rec = recognition;
        this.showMic = false;
        if (!this.showMic) {
          recognition.start();
        } else {
          recognition.stop();
        }

        recognition.onstart = () => {
          console.log('active');
        };

        recognition.onresult = (event) => {
          console.log(event.results[0][0].transcript);
          this.text = event.results[0][0].transcript;
        };

        recognition.onend = () => {
          console.log('not active');
          this.showMic = true;
          this.searchCompany(this.text);
        };
      } else {
        return console.log('not support');
      }
    },
    stop() {
      this.showMic = true;
      this.rec.stop();
      this.rec.onend = () => {
        console.log('not active');
      };
    },
    searchCompany(company) {
      let newRoute = this.$router.currentRoute.path;

      if (company && company.length > 0) {
        newRoute += '?company=' + company;
      }
      window.location = newRoute;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field input {
  font-size: 1.2em !important;
}

#search-input-wrap #search-input {
  color: red !important;
}

@media only screen and (min-width: 600px) {
  input#search-input.search-input {
    font-size: 24px !important;
  }

  #search-input-wrap {
    border: 1px solid red;
    padding: 10px 5px;
  }
}
</style>
